import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getExportSchedule = async ({ month, year }) => {
  const response = await SigliveServiceV1({
    method: 'GET',
    url: `/schedule/export`,
    params: { month, year },
    responseType: 'blob',
  });

  return response;
};

export default getExportSchedule;
